import { VideoOff } from "lucide-react";
import { useEffect, useRef } from "react";

type Props = {
  stream: MediaStream | null;
  cameraOn: boolean;
  className?: string;
};

export const SelfView = ({ stream, cameraOn, className }: Props) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) videoRef.current.srcObject = stream;
  }, [stream]);

  return (
    <div className={`a25-self-view ${className ?? ""}`}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        aria-label="Your camera preview"
        hidden={!cameraOn}
      />
      {!cameraOn && (
        <div className="a25-self-view-off">
          <VideoOff size={20} aria-hidden="true" />
          <span>Camera off</span>
        </div>
      )}
      <span className="a25-tile-label">You</span>
    </div>
  );
};
